/**
 * Created by abbeymart on 2017-02-18.
 */

import type { RouteRecordRaw } from 'vue-router';

export const contactRoutes: Array<RouteRecordRaw> = [
  {
    path: '/contact',
    name: 'contact',
    redirect: '/contact/list',
    component: () => import('pages/central/contact/McContact.vue'),
    meta: {
      title: 'Contacts Management',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:contactGroup?/:contactGroupId?',
        name: 'contactList',
        component: () => import('pages/central/contact/ContactList.vue'),
        meta: {
          title: 'Contacts List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:contactGroup?/:contactGroupId?',
        name: 'contactDetail',
        component: () => import('pages/central/contact/ContactDetail.vue'),
        meta: {
          title: 'Contact Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'contactNew',
        component: () => import('pages/central/contact/ContactNew.vue'),
        meta: {
          title: 'New Contact',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/address',
    name: 'address',
    redirect: '/address/list',
    component: () => import('pages/central/address/McAddress.vue'),
    meta: {
      title: 'Address',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'addressList',
        component: () => import('pages/central/address/AddressList.vue'),
        meta: {
          title: 'Addresses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'addressDetail',
        component: () => import('pages/central/address/AddressDetail.vue'),
        meta: {
          title: 'Address Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'addressNew',
        component: () => import('pages/central/address/AddressNew.vue'),
        meta: {
          title: 'New Address',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/phone',
    name: 'phone',
    redirect: '/phone/list',
    component: () => import('pages/central/phone/McPhone.vue'),
    meta: {
      title: 'Phones',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'phoneList',
        component: () => import('pages/central/phone/PhoneList.vue'),
        meta: {
          title: 'Phones List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'phoneDetail',
        component: () => import('pages/central/phone/PhoneDetail.vue'),
        meta: {
          title: 'Phone Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'phoneNew',
        component: () => import('pages/central/phone/PhoneNew.vue'),
        meta: {
          title: 'New Phone',
          requiresAuth: true,
        },
      },
    ],
  },
];


// to => ({
//             name  : "phoneList",
//             params: {contactId: to.params.contactId, ownerId: to.params.ownerId},
//         })
